import { Row, Col } from 'react-bootstrap';

export default function LGPDAlepe() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/dados-pessoais">Proteção de Dados Pessoais (LGPD)</a> / LGPD na Alepe</small></p>
        </Col>
        <Col xs="12">
            <h1>LGPD na Alepe</h1>
            <p>A Lei Federal 13.709/2018, mais conhecida como Lei Geral de Proteção de Dados Pessoais (LGPD), foi aprovada para que o cidadão tenha mais controle sobre suas próprias informações, reforçando direitos fundamentais como a liberdade e a privacidade. </p>
            <h1>Encarregado</h1>
            <p>De acordo com a LGPD, encarregado é pessoa indicada para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).</p>
            <p>Solicitações relativas a dados pessoais controlados pela Assembleia Legislativa de Pernambuco devem ser encaminhadas ao encarregado de dados pessoais da Alepe:</p>
            <h3>João Victor Rocha Leandro</h3>
            <p>Encarregado | Gerência de Proteção de Dados Pessoais</p>
            <p>Contato:<br/>encarregado.lgpd@alepe.pe.gov.br<br/>(81) 3183-2003</p>
        </Col>
    </Row>
}